<template>
    <div>
        <v-dialog
            overlay-color="white"
            width="800px">
            <template v-slot:activator="{ on, attrs }">
                <div
                    v-bind="attrs"
                    v-on="on"
                    class="list-tooltip"
                    title="Aqumulate"
                    style="vertical-align: text-bottom; display: inline">
                    <v-icon small>mdi-lead-pencil</v-icon>
                </div>
            </template>
            <v-card>
                <v-card-title>Integrate Aqumulate</v-card-title>
                <v-card-text>
                    <aqumulate
                        :active="aqumulateIntegratd"
                        :username-prop="aqumulateUsername"
                        :last-updated="aqumulateLastUpdated"></aqumulate>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Aqumulate from "@/components/aqumulate/Aqumulate";

export default {
    components: {
        Aqumulate
    },

    computed: {
        ...mapState('aqumulate', {
            aqumulateIntegratd: 'integrated',
            aqumulateLastUpdated: 'lastUpdated',
            aqumulateUsername: 'username'
        })
    }
}
</script>
